import gql from 'graphql-tag';

const DESTROY_SERVICE_RUN = gql`
	mutation destroyServiceRunMutation ($id: ID!) {
		destroyServiceRun(id: $id)
	}
`;

export default DESTROY_SERVICE_RUN;
